import {
  Box,
  HStack,
  Pressable,
  Text,
  VStack,
  useMediaQuery,
} from "native-base";
import { Svg } from "react-native-svg";
import {
  attachmentFileSVG,
  deleteCardsIconSVG,
  downloadIconSVG,
} from "../../utils/svg";
import { COLORS } from "../../utils/colors";
import ContainerCards from "../../components/cards";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import "./style.css";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import CustomModal from "../../components/modal";
import { useState } from "react";
import ImageViewer from "../../components/imageViewer";
import ImageViewerJs from "../../components/imageViewer/viewer";
import FileViewerComponent from "../../components/fileViewer";
import MobileModelSheet from "../../components/actionSheet";
import download from "downloadjs";
import CustomButton from "../../components/button";
import { setIsDownloading } from "../../store/reducers/eventSlice";
import { useDispatch } from "react-redux";
import config from "../../utils/config";
import { deleteWalletAPI } from "../../api/apis/quicklinks";
import { Toaster } from "../../components/toaster";
import { LoaderAnimation } from "../../components/spinner";
import { hasPermission } from "../../utils/permission";
import CryptoJS from "crypto-js";

const AttachmentsCards = ({
  fileName = "file",
  timeline = "",
  path = "",
  fileSize = "0",
  scrollToTop = () => {},
  height = "auto",
  wallet = false,
  color = COLORS.ATTACHMENT_FILES_COLOR,
  deleteIcon = false,
  translateY = "-8px",
  onDeleteFile = () => {},
  minW = "344px",
  border = true,
  dashboard = false,
  width = "80%",
  quotation = false,
  id = "",
  walletId = "",
  onWalletDelete = () => {},
  addedBy = "",
  onDownloadFile = () => {},
}) => {
  const customTextStyle = {
    transform: [{ translateX: 0 }, { translateY: translateY }],
    height: "10px",
  };
  const dispatch = useDispatch();
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [showModal, setShowModal] = useState(false);
  const extension = ["png", "jpg", "jpeg"];
  const [selectedAction, setSelectedAction] = useState("");
  // const fileExtension = ["csv", "xls", "xlsx"];

  // Get current user email
  const getCurrentUserEmail = () => {
    try {
      const content = sessionStorage.getItem("content");
      if (content) {
        const bytes = CryptoJS.AES.decrypt(content, config.userKey);
        const jsonString = bytes.toString(CryptoJS.enc.Utf8);
        const userInfo = JSON.parse(jsonString);
        return userInfo?.email || "";
      }
    } catch (error) {
      console.error('Error getting user email:', error);
    }
    return "";
  };

  // Check if user can delete wallet
  const canDeleteWallet = () => {
    if (!wallet || !walletId) return false;
    
    const currentUserEmail = getCurrentUserEmail();
    const isAdmin = hasPermission('ADMIN');
    const isOwner = currentUserEmail === addedBy;
    return isAdmin || isOwner;
  };

  const openModal = () => {
    // Use local scrollToTop function if prop is not available
    if (!MobileWindow) {
      if (typeof scrollToTop === 'function' && scrollToTop.toString() !== '() => {}') {
        scrollToTop();
      } else {
        // Fallback to direct scroll implementation
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedAction("");
    }, 300);
  };

  const getFormattedDate = (dates) => {
    const originalDate = new Date(dates);

    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
      timeZone: "UTC",
    }).format(originalDate);

    return formattedDate;
  };

  const handleDeleteWallet = async () => {
    if (walletId) {
      try {
        LoaderAnimation.show();
        const res = await deleteWalletAPI(walletId);
        LoaderAnimation.hide();
        if (res.error) {
          toaster(res.message, "error", "error");
        } else {
          toaster(res?.data?.data?.data || "Wallet deleted successfully", "success", "success");
          onWalletDelete();
        }
      } catch (error) {
        LoaderAnimation.hide();
        toaster("Error deleting wallet", "error", "error");
      }
    }
    closeModal();
  };

  const getModalHeader = () => {
    if (selectedAction === "delete_file" && !quotation) {
      return <>Delete Expense</>;
    } else if (selectedAction === "delete_file" && quotation) {
      return <>Delete Quotation</>;
    } else if (selectedAction === "delete_wallet") {
      return <>Delete Wallet</>;
    } else
      return (
        <HStack
          justifyContent={"space-between"}
          width={MobileWindow ? (quotation ? "85%" : "90%") : "95%"}
        >
          <Text width={MobileWindow && "100%"}>{fileName}</Text>
          <Pressable
            onPress={() => {
              dispatch(setIsDownloading(true));
              const parts = path.split("_");
              const filename = parts.slice(1).join("_").trim();
              const sanitizedFilename = decodeURIComponent(filename).replace(
                /^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g,
                ""
              );

              fetch(path)
                .then((response) => response.blob())
                .then((blob) => {
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = sanitizedFilename;
                  document.body.appendChild(a);
                  a.click();
                  window.URL.revokeObjectURL(url);
                  // Call onDownloadFile callback after successful download
                  if (typeof onDownloadFile === 'function') {
                    onDownloadFile(path);
                  }
                })
                .catch((error) => {
                  console.error("Error downloading file:", error);
                });
              dispatch(setIsDownloading(false));
            }}
          >
            <Box mt={MobileWindow && 1}>
              <Svg width="50" height="40" viewBox="0 0 1 36">
                {downloadIconSVG}
              </Svg>
              {/* <i
                className="fa fa-download pointer"
                style={{ color: "black" }}
              ></i> */}
            </Box>
          </Pressable>
        </HStack>
      );
    // else return fileName;
  };

  const getModalChildren = () => {
    if (selectedAction === "delete_file") {
      return (
        <Box justifyContent={"center"} alignItems={"center"} mt={"20px"}>
          <Text
            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            Are you sure, want to delete this file?
          </Text>
        </Box>
      );
    } else if (selectedAction === "delete_wallet") {
      return (
        <Box justifyContent={"center"} alignItems={"center"}>
          <Text
            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            Are you sure, want to delete this wallet?
          </Text>
        </Box>
      );
    } else {
      const extension = path.split(".").pop();
      return extension === "png" ||
        extension === "jpeg" ||
        extension === "jpg" ? (
        <ImageViewer path images={[{ path: path }]} />
      ) : (
        <Box>
          <FileViewerComponent path={path} height="68vh" />
        </Box>
        // <Box>
        //   <iframe
        //     src={path}
        //     title="document"
        //     width="100%"
        //     height="auto"
        //     style={{
        //       border: "none",
        //       minHeight: MobileWindow ? "65vh" : "81vh",
        //       maxHeight: "90vh",
        //       marginTop: MobileWindow ? 0 : "10px",
        //     }}
        //   />
        // </Box>
      );
    }
  };

  const getPopUpModalFooter = () => {
    if (selectedAction === "delete_file")
      return (
        <>
          {/* <Box
            width={MobileWindow && "50%"}
            justifyContent={MobileWindow && "center"}
            alignItems={MobileWindow && "center"}
          >
            <Text
              onPress={closeModal}
              color={COLORS.MODAL_BACK_BUTTON_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              mt={3}
              mr={12}
            >
              Back
            </Text>
          </Box> */}
          <Box width={MobileWindow && "100%"} alignItems="flex-end">
            <CustomButton
              onPress={() => {
                closeModal();
                if (dashboard) onDeleteFile(id);
                else onDeleteFile(path);
              }}
              text="Confirm"
              color={COLORS.WHITE_COLOR}
            />
          </Box>
        </>
      );
    else if (selectedAction === "delete_wallet")
      return (
        <>
          <Box width={MobileWindow && "100%"} alignItems="flex-end">
            <CustomButton
              onPress={handleDeleteWallet}
              text="Confirm"
              color={COLORS.WHITE_COLOR}
            />
          </Box>
        </>
      );
  };

  function formatFileSize(fileSize) {
    const kilobyte = 1024;
    const megabyte = 1024 * kilobyte;
    const gigabyte = 1024 * megabyte;

    if (fileSize < kilobyte) {
      return fileSize + " bytes";
    } else if (fileSize < megabyte) {
      const sizeInKB = fileSize / kilobyte;
      return sizeInKB.toFixed(1) + " KB";
    } else if (fileSize < gigabyte) {
      const sizeInMB = fileSize / megabyte;
      return sizeInMB.toFixed(2) + " MB";
    } else {
      const sizeInGB = fileSize / gigabyte;
      return sizeInGB.toFixed(2) + " GB";
    }
  }

  const downloadFile = (path) => {
    dispatch(setIsDownloading(true));
    try {
      const parts = path.split("_");
      const filename = parts.slice(1).join("_").trim();
      const sanitizedFilename = decodeURIComponent(filename).replace(
        /^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g,
        ""
      );

      fetch(path)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = sanitizedFilename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          // Call onDownloadFile callback after successful download
          if (typeof onDownloadFile === 'function') {
            onDownloadFile(path);
          }
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    } catch (error) {
      console.error("Error downloading file:", error);
    }
    dispatch(setIsDownloading(false));
  };

  return (
    <>
      <ContainerCards
        width="100%"
        maxW="auto"
        minW={MobileWindow ? "100%" : minW}
        minH="75px"
        height={deleteIcon ? "fit-content" : height}
        borderRadius="8px"
        border={border && "1px solid " + COLORS.ATTACHMENT_FILES_BORDER_COLOR}
        background={color}
        boxShadow="none"
        mb={1}
      >
        <HStack
          space={2}
          width={"100%"}
          justifyContent={"space-between"}
          // pb={!deleteIcon && 2}
        >
          <HStack
            pl={4}
            width={dashboard ? (MobileWindow ? "76%" : "92%") : width}
          >
            <Svg width="40" height="60" viewBox="0 0 1060 600">
              {attachmentFileSVG}
            </Svg>
            <VStack my={3} width={MobileWindow ? "inherit" : "88%"}>
              <Text
                fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
                fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                color={COLORS.ATTACHMENTS_TEXT_COLOR}
                pb="5px"
              >
                {fileName}
              </Text>
              <HStack>
                <Text
                  fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                  fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                  color={COLORS.ATTACHMENTS_TEXT_COLOR}
                >
                  {timeline && getFormattedDate(timeline)}
                </Text>
                {fileSize && fileSize !== "0" && fileSize !== "" && (
                  <>
                    <Text fontSize="2rem" ml={2} mr={2} style={customTextStyle}>
                      .
                    </Text>
                    <Text
                      fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                      fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                      color={COLORS.ATTACHMENTS_TEXT_COLOR}
                    >
                      {formatFileSize(fileSize)}
                    </Text>
                  </>
                )}
              </HStack>
            </VStack>
          </HStack>
          <HStack alignItems="center" justifyContent="center" space={3}>
            {/* Delete icon for ALL wallet items (images AND documents) */}
            {(deleteIcon || (wallet && walletId && canDeleteWallet())) && (
              <Pressable
                onPress={() => {
                  if (wallet && walletId) {
                    setSelectedAction("delete_wallet");
                  } else {
                    setSelectedAction("delete_file");
                  }
                  openModal();
                }}
              >
                <Box
                  mt={2}
                  mr={dashboard && 1}
                  width={MobileWindow ? "15%" : "20%"}
                >
                  <Svg width="24" height="20" viewBox="0 0 24 24">
                    {deleteCardsIconSVG}
                  </Svg>
                </Box>
              </Pressable>
            )}
            
            {/* Image viewer for images OR download for documents */}
            {path.split(".").pop() === "png" ||
            path.split(".").pop() === "jpg" ||
            path.split(".").pop() === "jpeg" ? (
              <Pressable>
                <Box mt={7} mr={wallet ? 1 : 6} width={MobileWindow && "15%"}>
                  <ImageViewerJs src={path} />
                </Box>
              </Pressable>
            ) : (
              <Pressable
                onPress={() => {
                  if (wallet) {
                    setSelectedAction("view_file");
                    openModal();
                  } else {
                    // Scroll to top for download action
                    if (!MobileWindow) {
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }
                    downloadFile(path);
                  }
                }}
              >
                <Box
                  mt={5}
                  mr={4}
                  // ml={6}
                  width={
                    MobileWindow ? (wallet ? "48%" : "8%") : dashboard && "10%"
                  }
                  alignItems={"center"}
                >
                  {!quotation ? (
                    <Svg width="50" height="40" viewBox="0 0 1 36">
                      {downloadIconSVG}
                    </Svg>
                  ) : MobileWindow ? (
                    <Svg width="20" height="40" viewBox="0 0 20 36">
                      {downloadIconSVG}
                    </Svg>
                  ) : (
                    <Svg width="50" height="40" viewBox="0 0 20 36">
                      {downloadIconSVG}
                    </Svg>
                  )}
                  {/* <i className="fa fa-download pointer"></i> */}
                </Box>
              </Pressable>
            )}
          </HStack>
        </HStack>
      </ContainerCards>

      {showModal && !MobileWindow ? (
        <CustomModal
          size=""
          top={selectedAction === "delete_wallet" || selectedAction === "delete_file" || selectedAction === "view_file" ? undefined : "20px"}
          isOpen={showModal}
          onClose={closeModal}
          header={getModalHeader()}
          body={showModal && getModalChildren()}
          footer={getPopUpModalFooter()}
          width={
            selectedAction === "delete_wallet"
              ? "40%"
              : extension.includes(path.split(".").pop()) ||
                selectedAction === "delete_file" ||
                selectedAction === "view_file"
              ? "fit-content"
              : "auto"
          }
          height={
            selectedAction === "view_file"
              ? "80vh"
              : extension.includes(path.split(".").pop()) ||
                selectedAction === "delete_file" ||
                selectedAction === "delete_wallet"
              ? "fit-content"
              : "80vh"
          }
          fixedPosition={selectedAction === "delete_wallet" || selectedAction === "delete_file" || selectedAction === "view_file" ? false : true}
          fixedTop={selectedAction === "delete_file" ? 180 : undefined}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={getModalHeader()}
          body={showModal && getModalChildren()}
          footer={getPopUpModalFooter()}
          maxH={"80vh"}
          position="hidden"
        />
      )}
    </>
  );
};

export default AttachmentsCards;
